import React from 'react';
import { motion } from 'framer-motion';
import { ExternalLink } from 'lucide-react';
export interface RestaurantProps {
  name: string;
  url: string;
  address: string;
  description: string;
  menuItems: string[];
  menuLabel?: string;
  image: string;
  index: number;
}
export function RestaurantCard({
  name,
  url,
  address,
  description,
  menuItems,
  menuLabel = 'Tasting Notes',
  image,
  index
}: RestaurantProps) {
  const isEven = index % 2 === 0;
  return <div className="py-24 border-b border-neutral-800 last:border-0" data-id="element-54">
      <div className={`flex flex-col ${isEven ? 'lg:flex-row' : 'lg:flex-row-reverse'} gap-12 lg:gap-24 items-center`} data-id="element-55">
        {/* Image Side */}
        <motion.div className="w-full lg:w-1/2 relative group" initial={{
        opacity: 0,
        y: 40
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} data-id="element-56">
          <div className="aspect-[4/5] overflow-hidden relative" data-id="element-57">
            <div className="absolute inset-0 bg-neutral-900/20 z-10 transition-opacity duration-500 group-hover:opacity-0" data-id="element-58"></div>
            <img src={image} alt={name} className="w-full h-full object-cover transition-transform duration-1000 group-hover:scale-105" data-id="element-59" />
          </div>
        </motion.div>

        {/* Content Side */}
        <motion.div className="w-full lg:w-1/2 flex flex-col" initial={{
        opacity: 0,
        x: isEven ? 40 : -40
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8,
        delay: 0.2,
        ease: 'easeOut'
      }} data-id="element-60">
          <div className="mb-8" data-id="element-61">
            <p className="text-amber-500 uppercase tracking-[0.2em] text-xs font-medium mb-4" data-id="element-62">
              {address}
            </p>
            <h3 className="text-4xl md:text-5xl font-serif text-stone-50 mb-6" data-id="element-63">
              {name}
            </h3>
            <p className="text-stone-400 text-lg leading-relaxed font-light" data-id="element-64">
              {description}
            </p>
          </div>

          <div className="mb-12" data-id="element-65">
            <h4 className="text-xs font-medium text-stone-500 uppercase tracking-[0.2em] mb-6" data-id="element-66">
              {menuLabel}
            </h4>
            <ul className="space-y-4" data-id="element-67">
              {menuItems.map((item, i) => <li key={i} className="flex items-center text-stone-300 font-light" data-id="element-68">
                  <span className="w-8 h-px bg-neutral-800 mr-4" data-id="element-69"></span>
                  {item}
                </li>)}
            </ul>
          </div>

          <a href={url} target="_blank" rel="noopener noreferrer" className="inline-flex items-center self-start group" data-id="element-70">
            <span className="text-stone-50 font-medium uppercase tracking-widest text-sm mr-4 group-hover:text-amber-500 transition-colors" data-id="element-71">
              Visit Website
            </span>
            <div className="w-10 h-10 rounded-full border border-neutral-700 flex items-center justify-center group-hover:border-amber-500 transition-colors" data-id="element-72">
              <ExternalLink className="w-4 h-4 text-stone-400 group-hover:text-amber-500 transition-colors" data-id="element-73" />
            </div>
          </a>
        </motion.div>
      </div>
    </div>;
}